var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_697_2805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 42.6667C36.4183 42.6667 40 39.085 40 34.6667C40 30.2485 36.4183 26.6667 32 26.6667C27.5817 26.6667 24 30.2485 24 34.6667C24 39.085 27.5817 42.6667 32 42.6667Z",
    stroke: "#56AB2F",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 18.6667H18.6667C20.0812 18.6667 21.5453 18.4549 22.5455 17.4547M13.3333 18.6667C11.9188 18.6667 10.5623 19.2287 9.5621 20.2288C8.5619 21.229 8 22.5856 8 24.0001V48.0001C8 49.4146 8.5619 50.7711 9.5621 51.7713C10.5623 52.7715 11.9188 53.3334 13.3333 53.3334H50.6667C52.0812 53.3334 53.4377 52.7715 54.4379 51.7713C55.4381 50.7711 56 49.4146 56 48.0001V29.3334M13.3333 18.6667L22.5455 17.4547M22.5455 17.4547C23.5456 16.4545 24 14.7479 24 13.3334C24 12.6262 24.281 11.9479 24.781 11.4478C25.2811 10.9477 25.9594 10.6667 26.6667 10.6667H32L25.8595 10.7918L22.5455 17.4547Z",
    stroke: "#56AB2F",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 16H56",
    stroke: "#A8E063",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 8V24",
    stroke: "#A8E063",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_697_2805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.dee6ea579d128f850c2f7ca76173a2e1.svg";
export { ForwardRef as ReactComponent };